// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__PMxb1","left":"InfoRow_left__28I9Z"};